import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './habit-form-error.style';

export type HabitFormErrorProps = {
  onRetry: () => void;
  onCancel: () => void;
  isEdit?: boolean;
};

export const HabitFormError: React.FC<HabitFormErrorProps> = ({
  onRetry,
  onCancel,
  isEdit,
}) => {
  const { t } = useTranslation();
  return (
    <Styled.Container>
      <Styled.Body>
        <Typography variant="h2">
          {t(
            isEdit
              ? 'forms.habit.retry.edit.title'
              : 'forms.habit.retry.create.title',
          )}
        </Typography>
        <Typography variant="overline">
          {t(
            isEdit
              ? 'forms.habit.retry.edit.description'
              : 'forms.habit.retry.create.description',
          )}
        </Typography>
      </Styled.Body>
      <Styled.Interactions>
        <Button
          variant={Variants.Outlined}
          size={Sizes.Medium}
          onClick={onCancel}
          type="button"
        >
          {t('forms.habit.retry.cancel.label')}
        </Button>
        <Button size={Sizes.Medium} type="submit" onClick={onRetry}>
          {t('forms.habit.retry.save.label')}
        </Button>
      </Styled.Interactions>
    </Styled.Container>
  );
};
